import { Linking } from "react-native"
import { SPOTIFY_PLAYER_URL } from "../../utils/constants/connectionConstants"

export const useOpenSpotifyApp = () => {
    const openOnBrowser = () => {
        window.open(SPOTIFY_PLAYER_URL, "_blank");
    }

    return () => {
        Linking.canOpenURL(SPOTIFY_PLAYER_URL)
            .then((result) => {
                if(result)
                {
                    Linking.openURL(SPOTIFY_PLAYER_URL)
                        .catch(() => {
                            openOnBrowser();
                        });
                }
                else
                {
                    openOnBrowser();
                }
            })
            .catch(() => {
                openOnBrowser();
            });
    }
}